import { useRouter } from 'next/router'

export const getEventLocationFromPath = (pathname: string): string => {
  const pathSegments = pathname
    .split('/')
    .filter((segment) => segment.length > 0)

  const actualPath =
    pathSegments.length > 2 ? `/${pathSegments.slice(2).join('/')}` : pathname

  if (actualPath === '/products') {
    return 'products_home'
  }

  if (actualPath.startsWith('/products/')) {
    const category = actualPath.split('/')[2]

    switch (category) {
      case 'best-sellers': {
        return 'products_best_sellers'
      }
      case 'feel-great': {
        return 'products_feel_great'
      }
      case 'packs': {
        return 'products_packs'
      }
      case 'accessories': {
        return 'products_accessories'
      }
      case 'unicity-labs': {
        return 'products_unicity_labs'
      }
      default: {
        const formattedCategory = category.replaceAll('-', '_')
        const result = `products_${formattedCategory}`
        return result
      }
    }
  }

  if (actualPath.startsWith('/product/')) {
    return 'product_page'
  }

  return 'products_home'
}

export const useEventLocation = (): string => {
  const router = useRouter()
  const result = getEventLocationFromPath(router.asPath)
  return result
}
